module.exports = __webpack_public_path__ + "img/bg_thank_you.svg";